import { useState, useEffect } from 'react';
import componentNotifier from '../services/wss/ComponentNotifier';
import calEventEditEngine from './Core/CalEventEditEngine';

/**
 * useCalEventEdit — observer hook for CalEventEditEngine.
 * Subscribes to 'editChanged' — only components using this hook repaint
 * when the edit session starts/ends, not the entire CalendarWidget tree.
 * @returns {{
 *   editingRk: string|null,
 *   newEventDraft: CalEventObj|null,
 *   startEdit: function(string): void,
 *   endEdit: function(): void,
 * }}
 */
export function useCalEventEdit() {
    const [state, setState] = useState(() => ({
        editingRk: calEventEditEngine.getEditingRk(),
        newEventDraft: calEventEditEngine.getNewEventDraft(),
    }));

    useEffect(() => {
        /**
         * Syncs local state with the engine on every edit change.
         * Single setState call — avoids a double render from two separate
         * setState calls outside a React event handler.
         * @param {{ data: { editingRk: string|null, newEventDraft: CalEventObj|null } }} e
         */
        const handleEditChanged = (e) => {
            setState({ editingRk: e.data.editingRk, newEventDraft: e.data.newEventDraft });
        };

        return componentNotifier.subscribe('editChanged', handleEditChanged);
    }, []);

    return {
        editingRk: state.editingRk,
        newEventDraft: state.newEventDraft,
        startEdit: calEventEditEngine.startEdit,
        endEdit: calEventEditEngine.endEdit,
    };
}
